// @flow
import React from 'react';
import Button from 'app/common/ui/Button';
import IconBtnGo from 'app/components/_Icons/IconBtnGo';
import Modal from 'app/common/components/Modal';
import { Trans } from 'react-i18next';

import ElJurGoTo from 'app/components/ElJurDnevnik/ElJurGoTo';
import enhanceElJurLogin from 'app/containers/ElJur/enhanceElJurLogin';
import styles from './ElJurFooter.scss';


type Props = {
  tokenData: {
    isSaved: boolean,
  },
  ejLoginUrl: string,
  error: string,
  isLogin: boolean,
  handleShowLogin: (e: SyntheticEvent<HTMLElement>) => void,
  handleCloseLogin: (e: SyntheticEvent<HTMLElement>) => void,
  savingToken: boolean,
};

const ElJurFooter = ({
  tokenData: { isSaved },
  ejLoginUrl,
  error,
  isLogin,
  handleShowLogin,
  handleCloseLogin,
  savingToken,
}: Props) =>
  <div className={styles.root}>
    <div className={styles.info}>
      {error}
    </div>
    {!isSaved
      ? <Button href="" onClick={handleShowLogin} disabled={savingToken}>
        {savingToken
          ? <Trans i18nKey="subs:open_bt_loading">
            {'Подождите...'}
          </Trans>
          : <span>
            <Trans i18nKey="subs:open_bt">
              {'Открыть'}
            </Trans>
            <IconBtnGo />
          </span>}
      </Button>
      : <ElJurGoTo>
        <Trans i18nKey="subs:open_bt">
          {'Открыть'}
        </Trans>
        <IconBtnGo />
      </ElJurGoTo>
    }
    {isLogin
      && <Modal className={styles.modal} overlayClassName={styles.overlay}>
        <Button onClick={handleCloseLogin} className={styles.modalClose}>
          <Trans i18nKey="subs:close_bt">
            {'Закрыть'}
          </Trans>
        </Button>
        <iframe src={ejLoginUrl} title="ElJur" width="980" height="620" frameBorder="0" />
      </Modal>
    }
  </div>;

export default enhanceElJurLogin(ElJurFooter);
